import useLocalStorage from "../Tools/localstorage/useLocalStorageStatus";
import Config from "./Config";
import FavList from "./FavList";
import TagController from "./TagController";

const Block = ({ title, children, closed, onClick }) => {
  if (closed)
    return (
      <div className="bg-white rounded-lg shadow-sm p-2 text-center border border-gray-100 relative">
        <h2
          className="text-sm font-semibold text-gray-700"
          onClick={() => onClick(title)}
        >
          {title}
        </h2>
      </div>
    );

  // console.log(title, onClick)
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 text-center border border-gray-100 relative">
      {onClick && (
        <button
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors duration-200"
          onClick={() => onClick(title)}
          aria-label="关闭"
        >
          ×
        </button>
      )}

      <h2 className="text-xl font-semibold text-gray-700 mb-3">{title}</h2>
      {children}
    </div>
  );
};

const HelpPage = ({ onClick }) => {
  const [isClosedMap, setIsClosedMap] = useLocalStorage("closedMap", {});

  const handleOnClickBlock = (blockTitle) => {
    setIsClosedMap((prev) => ({
      ...prev,
      [blockTitle]: !(prev[blockTitle] ?? false),
    }));
  };
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      {/* 豆腐块容器 - 使用Grid布局实现居中豆腐块 */}
      <div className="max-w-md mx-auto grid grid-cols-1 gap-2">

        {/* 豆腐块0 - 广告插入问题 */}
        <Block
          title="关于广告插入问题"
          closed={isClosedMap["广告插入问题"]}
          onClick={() => handleOnClickBlock("广告插入问题")}
        >
          <p className="text-gray-500">
            如有任何意见建议请到聊天室问答。
          </p>
          <p className="text-gray-500">
            <button
              onClick={() => window.open("https://chatto.moonchan.xyz", "_blank")}
              style={{
                display: "inline-block",
                padding: "8px 20px",
                background: "linear-gradient(135deg, #a04ab8, #8041a6)",
                color: "#fff",
                border: "none",
                borderRadius: "18px",
                fontWeight: "bold",
                fontSize: "16px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
                cursor: "pointer",
              }}
            >
              点击添加聊天群
            </button>
          </p>
        </Block>

        <Block
          title="DeepSeek V4.1 太牛啦"
          closed={isClosedMap["dsv4.1f"]}
          onClick={() => handleOnClickBlock("dsv4.1f")}
        >
          <p className="text-gray-500">
            大改版，非常好用！推荐下载这个。昨天那个apk写的什么区
            <br />
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://github.com/Hana-ame/twitter-pic-flutter/releases/latest/download/app-release.apk"
            >
              最新版（官方）
            </a>
            <br />
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://gh-proxy.org/https://github.com/Hana-ame/twitter-pic-flutter/releases/latest/download/app-release.apk"
            >
              最新版（国内镜像）
            </a>
          </p>
          <p className="text-gray-500">
            另外x.810114.xyz被举报，可以分流到<a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://x.4545810.xyz"
            >
              x.4545810.xyz
            </a>
          </p>
        </Block>
        
        {/* 豆腐块4 - ech-proxy 本地代理 */}
        <Block
          title="本地代理 ech-proxy"
          closed={isClosedMap["本地代理 ech-proxy"]}
          onClick={handleOnClickBlock}
        >
          <p className="text-gray-500">
            一个手机一个电脑，打开之后重新打开网页就能使用本地代理观看twitter视频了，并且同时附带 iwara / dlsite / sukebei 反向代理。所有数据不经过第三方服务器，流量直接从源站到你终端（这次不用担心用的人多把宽带挤爆炸了）。
          </p>
          <p className="text-gray-500">
            电脑 (Windows):
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://gh-proxy.org/https://github.com/Hana-ame/ech-proxy/releases/download/v1.0.0/ech-proxy-windows-amd64.exe"
            >
              ech-proxy-windows-amd64.exe
            </a>
          </p>
          <p className="text-gray-500">
            手机 (Android):
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://gh-proxy.org/https://github.com/Hana-ame/ech-proxy/releases/download/v1.0.0/app-release.apk"
            >
              app-release.apk
            </a>
          </p>
          <p className="text-gray-500">
            操作说明：手机打开后是一片白，请稍微等待加载完成。完成后会跳转到 index 页面。如果出现打不开情况请考虑设置后台常驻。win端未测试，等你们用出问题再说。
          </p>
          <p className="text-gray-500">
            问题反馈方法——渠道1：请加chatto聊天群反馈（下方新开聊天室，房间「ECH Proxy」）。渠道2：托梦给我。我梦到了就处理。
          </p>
        </Block>

        {/* 豆腐块5 - 设置 */}
        <Block
          title="设置"
          closed={isClosedMap["设置"]}
          onClick={handleOnClickBlock}
        >
          <Config.ImageConfig />
          <br />
          <Config.CacheConfig />
        </Block>



        <Block
          title="新开聊天室"
          closed={isClosedMap["新开聊天室"]}
          onClick={() => handleOnClickBlock("新开聊天室")}
        >
          <p className="text-gray-500">
            <button
              onClick={() => window.open("https://chatto.moonchan.xyz", "_blank")}
              style={{
                display: "inline-block",
                padding: "8px 20px",
                background: "linear-gradient(135deg, #a04ab8, #8041a6)",
                color: "#fff",
                border: "none",
                borderRadius: "18px",
                fontWeight: "bold",
                fontSize: "16px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
                cursor: "pointer",
              }}
            >
              点击添加聊天群
            </button>
          </p>
          <p className="text-gray-500">
            注册不了可以在
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://chatto.810114.xyz"
            >
              https://chatto.810114.xyz
            </a>
            提交申请
          </p>
        </Block>

        <Block
          title="abuse"
          closed={isClosedMap["abuse"]}
          onClick={()=>handleOnClickBlock("abuse")}
        >
          <p className="text-gray-500">
<img src="https://r2.moonchan.xyz/1786762840/image.webp" alt="" />
          </p>
          <p className="text-gray-500">
            过两天挂了说明流量没了，22号恢复。
          </p>
          
        </Block>
        
        <Block
          title="每次挂了都没人提醒我😅"
          closed={isClosedMap["😅"]}
          onClick={()=>handleOnClickBlock("😅")}
        >
          <p className="text-gray-500">
            反正修好了，修了什么自己猜😅😅
          </p>
          <p className="text-gray-500">
            响应式用起来有点大病，回头让deepseek再改一个。
          </p>
          
        </Block>

        <Block
          title="给你们写了个akp"
          closed={isClosedMap["apk"]}
          onClick={()=>handleOnClickBlock("apk")}
        >
          <p className="text-gray-500">
              给你们写了个Andorid应用
          </p>
          
          <p className="text-gray-500">apk不走转发，暂时可以下载apk用</p>
          <p className="text-gray-500">免翻的,没梯子的用用</p>
          <p className="text-gray-500">但是没梯子为什么不挂下面的公共1T呢,下次不写了</p>
          <p className="text-gray-500">半成品,不打算更新,后来还是一直在更新,不过你还是可以
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://810114.xyz/?bid=103&tid=195456&pn=0"
            >
            提意见
            </a>
          </p>
          <p className="text-gray-500">
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://github.com/Hana-ame/twitter-pic-flutter/releases/tag/v0.7.10"
            >
              https://github.com/Hana-ame/twitter-pic-flutter/releases/tag/v0.7.10
            </a>
          </p>
          <p className="text-gray-500">
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://github.com/Hana-ame/twitter-pic-flutter/releases/latest/download/app-release.apk"
            >
              https://github.com/Hana-ame/twitter-pic-flutter/releases/latest/download/app-release.apk
            </a>
          </p>
          <p className="text-gray-500">
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://gh-proxy.com/github.com/Hana-ame/twitter-pic-flutter/releases/latest/download/app-release.apk"
            >
              https://gh-proxy.com/github.com/Hana-ame/twitter-pic-flutter/releases/latest/download/app-release.apk
            </a>
          </p>
          <p className="text-gray-500">
                    请测试反馈
          </p>
                      
          
          
        </Block>

        
        <Block
          title="给你们写了个本地代理"
          closed={isClosedMap["ech"]}
          onClick={() => handleOnClickBlock("ech")}
        >
          <p className="text-gray-500">给你们写了个本地代理,windows下跑的</p>
          
          <p className="text-gray-500">
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://upload.moonchan.xyz/api/01LLWEUU5K2FBYBJBN35C3RUAWJ2R66KJK/ech-proxy-windows-amd64.exe"
            >
              下载了打开就行
            </a>
          </p>
          
          <p>
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://pastebin.com/raw/bVDxpi4D"
            >
              代码点这里看,如果想自己编译的话.
            </a>
          </p>
          
          <p>
            运行之后看到这个
          </p>
            
          <img src="https://upload.moonchan.xyz/api/01LLWEUU2O5GC7P6H4VNFIUEBFCTXFAFCA/image.webp" alt="" />
          
          <p>
            然后把滚动条往下拉.填这个
          </p>
          
          <img src="https://upload.moonchan.xyz/api/01LLWEUU6T3LI4RG67EBHKWBBJJ7IGX2QK/image.webp" alt="" />
          
          <p>
            https://twimg.l.moonchan.xyz:8443
          </p>
          
          <p>
            有什么不会的自己问ai去.
          </p>
          
          <p className="text-gray-500">之后关闭twimg.moonchan.xyz服务的时候不再另行通知</p>

        </Block>


        <Block
          title="感觉有点被墙了"
          closed={isClosedMap["感觉有点被墙了"]}
          onClick={() => handleOnClickBlock("感觉有点被墙了")}
        >
          <p className="text-gray-500">感觉原版的节点都有点被墙了.</p>
          <p className="text-gray-500"><s>老用户往下拉有个设置,都切换到最后一个选项试试,这个选项是自建的.</s></p>
          <p className="text-gray-500">感觉这么薅扛不住,</p>
          <img src="https://upload.moonchan.xyz/api/01LLWEUU36JDUDKXO2INBJ7RPLRRT7OGTB/image.webp" alt="" />
          <p className="text-gray-500">你可以往下拉一点,找到这个代码,注册一下cloudflare,用这个代码贴到worker里建自己反代</p>
          <p className="text-gray-500"><s>不是那你们之前咋看的啊,怎么突然流量能薅这么多的.1.不看见vpn拼车2.之前看不了这站怎么能看到通知的,难不成我被打了?好心人能不能右下角聊天解惑</s></p>          
        </Block>
        
        <Block
          title="另外悄悄鉴证一下"
          closed={!isClosedMap["另外悄悄鉴证一下"]}
          onClick={() => handleOnClickBlock("另外悄悄鉴证一下")}
        >
          <p className="text-gray-500">s+可能有内鬼爬到管理员位置在乱删帖子,我之后就不上s+了.感觉贴吧时代就在搞这种斗争,希望是错觉吧.当然这是我个人意见,有前坛友在用的话不要去水区说这事.</p>
        </Block>

        <Block
          title="没嘎"
          closed={isClosedMap["服务器给压力爆了"]}
          onClick={() => handleOnClickBlock("服务器给压力爆了")}
        >
          <p className="text-gray-500">但是考虑迁出一部分人</p>
          <p className="text-gray-500">比如男同，重口什么的</p>
          <p className="text-gray-500">提供代码和技术指导，人柱力（twitter号）和服务器自己解决，不包维护。
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://810114.xyz/?bid=103"
            >
              这里讨论
            </a>，不免费。
          </p>
        </Block>
        <Block
          title="收藏导出位置"
          closed={isClosedMap["收藏导出位置"]}
          onClick={() => handleOnClickBlock("收藏导出位置")}
        >
          <p className="text-gray-500">在收藏夹的底部</p>
          <img src="https://upload.moonchan.xyz/api/01LLWEUU3QKVHBNYDZYJDZCOFH6YB2DASZ/image.webp" alt="" />
          <img src="https://upload.moonchan.xyz/api/01LLWEUU2YV5EZICJGBRGLXIQJETFIQ7DQ/image.webp" alt="" />
        </Block>
        <Block
          title="迁移"
          closed={isClosedMap["迁移"]}
          onClick={() => handleOnClickBlock("迁移")}
        >
          <p className="text-gray-500">请迁移至<a
            className="text-blue-500 cursor-pointer border-blue-700"
            href="https://x.810114.xyz/"
          >https://x.810114.xyz/</a>域名</p>
          <p className="text-gray-500">如遇问题，请允许使用剪贴板</p>
          <p className="text-gray-500">如允许后依然不能解决，请至</p>
          <p className="text-gray-500">
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://810114.xyz/?bid=893"
            >
              这里
            </a>上传你的操作流程。
          </p>
          <p className="text-gray-500">nmbyd3.top域名有效期至6月为止</p>
          <p className="text-gray-500">另外，收藏夹中尚未恢复的项目请自行手动添加</p>
          <p className="text-gray-500">更新后被发现的tag错误与添加时被发现的tag错误，封禁措施是相同的</p>
        </Block>
        <Block
          title="每月1T"
          closed={isClosedMap["翻墙"]}
          onClick={() => handleOnClickBlock("翻墙")}
        >
          <a
            className="text-blue-500 cursor-pointer border-blue-700"
            href="https://810114.xyz/?bid=810514"
          >点我看</a>
        </Block>
        
        <Block
          title="恢复"
          closed={isClosedMap["恢复"]}
          onClick={() => handleOnClickBlock("恢复")}
        >
          <p className="text-gray-500">傻逼印度人开的机房被勒索病毒黑了😅。</p>
          <p className="text-gray-500">
            数据按照回不来做打算，上次备份还是去年的。还没有tag的那部分。
          </p>

          <p className="text-gray-500">
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://810114.xyz/?bid=893"
            >
              导出收藏夹，在这里发送，择日进行批量添加。
            </a>
          </p>
        </Block>

        <Block
          title="Ban男同性恋决议"
          closed={isClosedMap["notice260117"]}
          onClick={() => handleOnClickBlock("notice260117")}
        >
          <p className="text-gray-500">
            男同性恋群体指令遵从性过于糟糕，即日起无条件直接ban
          </p>
          <p className="text-gray-500">
            （人话：给你们写tag功能不好好用，学不会那就别用了）
          </p>
          <p className="text-gray-500">
            先搞明白男娘两个字是什么意思吧
            <img src="https://upload.moonchan.xyz/api/01LLWEUU6JF65XQD3F6NEJHVFXPSNE66SL/image.webp" />
          </p>
          <p className="text-gray-500">
            性交呢，我请问了
            <img src="https://upload.moonchan.xyz/api/01LLWEUU32WYONYFXNRBBZTN6PHJKGX6UH/image.webp" />
          </p>
        </Block>
        <Block
          title="提示"
          closed={isClosedMap["notice260116"]}
          onClick={() => handleOnClickBlock("notice260116")}
        >
          <p className="text-gray-500">
            打错tag请自行down vote。否则看到会直接ban。
          </p>
        </Block>

        <Block
          title="迁移手滑了，只好回档了。我的锅"
          closed={isClosedMap["notice26"]}
          onClick={() => handleOnClickBlock("notice26")}
        >
          <p className="text-gray-500">现在添加twitter账号的时候必须带上tag</p>
          <p className="text-gray-500">
            不带的话会失败,失败的情况不会有提示,瞎敲会被ban
          </p>
          <p className="text-gray-500">另外,现在开始也可以为tag进行投票了</p>
          <p className="text-gray-500">
            在首页的tag设置栏目也可以选择高亮的tag和屏蔽的tag,往下拉一点就能看到
          </p>
          <p className="text-gray-500">
            另外,还顺带附有一些vmess翻墙订阅,不定期分享
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://810114.xyz/?bid=810514"
            >
              连接
            </a>
          </p>
        </Block>

        <Block
          title="提示"
          closed={isClosedMap["notice251220"]}
          onClick={() => handleOnClickBlock("notice251220")}
        >
          <p className="text-gray-500">
            自己搭建代理服务器，参考代码
            <a
              className="text-blue-500 cursor-pointer border-blue-700"
              href="https://pastebin.com/raw/3bL3GfAP"
            >
              https://pastebin.com/raw/3bL3GfAP
            </a>
          </p>
        </Block>

        {/* 豆腐块6 */}
        <Block
          title="守则"
          closed={isClosedMap["守则"]}
          onClick={handleOnClickBlock}
        >
          <p className="text-gray-500">
            二次元的女的和三次元的女的至少占一个你再加吧
          </p>
          <p className="text-gray-500">阳痿禁止使用本站</p>
        </Block>

        {/* 豆腐块4 */}
        <Block
          title="反馈"
          closed={isClosedMap["反馈"]}
          onClick={handleOnClickBlock}
        >
          <a href="https://810114.xyz/?bid=103">
            <p className="text-blue-500 cursor-pointer border-blue-700">
              任何反馈请点击这里。
            </p>
            <p className="text-gray-500">
              仔细描述问题,环境,操作步骤,并附上截图以获得解答
            </p>
          </a>
        </Block>

        <Block
          title="tag设置"
          closed={isClosedMap["tag设置"]}
          onClick={handleOnClickBlock}
        >
          <TagController></TagController>
        </Block>

        <Block
          title="收藏夹"
          closed={isClosedMap["收藏夹"]}
          onClick={handleOnClickBlock}
        >
          <FavList onClick={onClick}></FavList>
        </Block>
        {/* 豆腐块1 */}
        <Block
          title="开始游览"
          closed={isClosedMap["开始游览"]}
          onClick={handleOnClickBlock}
        >
          <p className="text-gray-500">
            在右侧点击想看的用户（手机点击右上角蓝色按钮）
          </p>
        </Block>

        {/* 豆腐块2 */}
        <Block
          title="如何添加"
          closed={isClosedMap["如何添加"]}
          onClick={handleOnClickBlock}
        >
          <p className="text-gray-500">在搜索栏中输入用户名（@之后的字符串）</p>
          <p className="text-gray-500">点击添加 @...</p>
          <p className="text-gray-500">等待一段时间后（约1分钟）刷新</p>
          <p className="text-gray-500">
            恭喜郁奈s打舞萌找到小男友,bilibili已取关,教程图就换成柴吧
            <img
              src="https://upload.moonchan.xyz/api/01LLWEUU474CGPN2VLB5FKOYKHSPQFGPL2/%E6%95%99%E7%A8%8B.webp"
              alt="https://upload.moonchan.xyz/api/01LLWEUUZ6EVLA2ZKA2NGL5OHMVYCIOR3F/image.png"
            />
          </p>
        </Block>

        {/* 豆腐块3 */}
        <Block
          title="推广"
          closed={isClosedMap["推广"]}
          onClick={handleOnClickBlock}
        >
          <a href="https://ex.810114.xyz/">
            <p className="text-blue-500 cursor-pointer border-blue-700">
              exhentai镜像，点我访问
            </p>
          </a>
        </Block>
      </div>

      {/* 底部填充区域 */}
      <div className="max-w-2xl mx-auto mt-10 text-center text-gray-400">
        <p className="mt-2">纯纯看图模式，文案？不存在的</p>
        <p className="mt-2">大概试过了应该可以不用翻墙的</p>
        <p className="mt-2">先开两天看看有没有人玩</p>
      </div>
    </div>
  );
};

export default HelpPage;
